export default {
	errors: {
		e400100: {
			title: 'Attention',
			message: 'Code de vérification invalide. Veuillez vérifier à nouveau.',
		},
		e400101: {
			title: 'Attention',
			message: 'Le compte doit être activé en premier. Vérifiez votre email.',
		},
		e400102: {
			title: 'Attention',
			message: 'Ce compte n\'existe pas sur notre plateforme ou a un mot de passe incorrect. Veuillez vérifier ceux que vous avez saisis à nouveau.',
		},
		e400103: {
			title: 'Attention',
			message: 'Mot de passe ou email invalide. Veuillez réessayer.',
		}
	}
}



// WEBPACK FOOTER //
// ./src/i18n/errors/errors_fr.js